import { render } from "./RootCanalSpecialist.vue?vue&type=template&id=05df72e4&scoped=true"
import script from "./RootCanalSpecialist.vue?vue&type=script&lang=js"
export * from "./RootCanalSpecialist.vue?vue&type=script&lang=js"

import "./RootCanalSpecialist.vue?vue&type=style&index=0&id=05df72e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05df72e4"]])

export default __exports__